import { useGLTF } from '@react-three/drei';
import { Shadow } from './_shadow';
import React, { useContext, useEffect, useRef, useState } from 'react';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import { LegFinishMaterial, UpholsteryMaterial } from '../../utils/materials';

export function Shelby_bench(props) {
  const { nodes, materials, scene } = useGLTF('models/Shelby Bench.glb');

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);
  const [shelbyOak, setShelbyOak] = useState(currentMaterialFinish.legFinish);

  useEffect(() => {
    const newFinish = { ...currentMaterialFinish.legFinish };

    if (newFinish.name === 'Limewash') {
      newFinish.diffuse = '../textures/wood-limewood-shelby.jpg';
    } else if (newFinish.name === 'Fruitwood') {
      newFinish.diffuse = '../textures/wood-fruitwood-shelby.jpg';
    } else if (newFinish.name === 'Java') {
      newFinish.diffuse = '../textures/wood-java-shelby.jpg';
    } else if (newFinish.name === 'Nordic') {
      newFinish.diffuse = '../textures/wood-nordic-shelby.jpg';
    }

    setShelbyOak(newFinish);
  }, [currentMaterialFinish.legFinish]);
  // console.log(shelbyOak,"shelbyOakshelbyOakshelbyOak")
  // uuid 72
  useSetMaterialFinish(
    UpholsteryMaterial,
    currentMaterialFinish.upholsteryFinish,
    defaultFinish.upholsteryFinish,
    'ao-shelby_bench-upholstery',
    aoIntensity,
  );
  useSetMaterialFinish(
    LegFinishMaterial,
    shelbyOak,
    defaultFinish.legFinish,
    'ao-shelby_bench-leg_finish',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh
        castShadow
        geometry={nodes.Upholstery.geometry}
        material={UpholsteryMaterial}
      />
      <mesh
        castShadow
        geometry={nodes.Leg_Finish.geometry}
        material={LegFinishMaterial}
      />
      <Shadow model={'Shelby Bench'} />
    </group>
  );
}
